import React, { useEffect, useState } from 'react'
import { Amplify, API, graphqlOperation } from 'aws-amplify'
import HeroSlider from '../components/UI/HeroSlider'
import Helmet from '../components/Helmet/Helmet'
import { Container, Row, Col } from 'reactstrap'
import SubmitForm from './RegisterForm'
import ServicesList from '../components/UI/ServicesList'
import ProductItem from '../components/UI/ProductItem'
import axios from 'axios';
import {listProductCategories} from '../graphql/queries'
import GalleryContent from './GalleryContent'

const listProductCategoryLinks = [{}]

const Home = () => {

  // const [categoryList, setcategoryList] = useState([]);

  // const fetchcategory = async () => {
  //   // Axios GET Default
  //   axios.get('http://localhost:4001/api/category').then((response) => {
  //    // console.log(response);
  //     setcategoryList(response.data);
  //   });
  // };

  // useEffect(() => {
  //   fetchcategory();
  // }, []);


//   const [listProductCat, setlistProductCat] = useState(listProductCategoryLinks)
  
//     useEffect( () => {
//       fetchTodos()
//    }, [])
//     const fetchTodos = async ()=> {
//        try {
//          const listProductCatData = await API.graphql(graphqlOperation(listProductCategories));
// console.log(listProductCatData, "listProductCatData")

//          const _productCategoriesList = listProductCatData?.data?.listProductCategories?.items
//          setlistProductCat(_productCategoriesList)
//        } catch (err) { console.log(err, 'error fetching listMenu') }
//      }


  return <Helmet title='Home'>
    <section className="p-0 hero__slider-section">
      <HeroSlider />
    </section>

   

     {/* ===============Productsection=============== */}
     <section className=''>
       <Container>
         <Row>
           {/* <Col lg='12 text-center mb-5'>
             <h2 className="section__title text-uppercase">Products</h2>
           </Col> */}
           {/* {
             categoryList.slice(0,6).map((item) => (
               <ProductItem item={item} key={item.id} />
             ))
           } */}
           <GalleryContent />
         </Row>
       </Container>
     </section>

      {/* ==============Services section======================= */}
     
      <section>
       <Container>
         <Row>
           <Col lg='12' className=' text-center'>
              {/* <h6 className="section__subtitle">See our</h6> */}
              <h2 className="section__title text-uppercase">Contact Us</h2>
           </Col>

           <ServicesList />
           {/* <SubmitForm /> */}
         </Row>
       </Container>
     </section>
  </Helmet>
}

export default Home
